import { ChevronDown, ChevronRight } from 'lucide-react'
import { type ReactNode, useId } from 'react'
import { cn } from '@/lib/utils'

interface UitklapperProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  label: string
  children: ReactNode
  knop?: ReactNode
  variant?: 'pijl' | 'knop'
  kop?: (knop: ReactNode) => ReactNode
  knopClassName?: string
  paneelClassName?: string
  className?: string
}

/**
 * De uitklapknop staat zelden alleen: hij zit in een regel met velden of tellingen
 * ernaast. Daarom krijgt `kop` de knop aangereikt en bepaalt de aanroeper zelf waar
 * die in die regel terechtkomt. Zonder `kop` staat de knop los boven het paneel.
 */
export function Uitklapper({
  open,
  onOpenChange,
  label,
  children,
  knop,
  variant = 'pijl',
  kop,
  knopClassName,
  paneelClassName,
  className,
}: UitklapperProps) {
  const paneelId = useId()
  const Pijl = open ? ChevronDown : ChevronRight

  const knopElement = (
    <button
      type="button"
      aria-expanded={open}
      aria-controls={paneelId}
      aria-label={label}
      onClick={() => onOpenChange(!open)}
      className={cn(
        variant === 'pijl' ? 'btn-ghost h-8 w-8 p-0' : 'btn-ghost h-7 px-2 text-xs',
        knopClassName,
      )}
    >
      {variant === 'pijl' ? <Pijl className="h-4 w-4" strokeWidth={1.85} /> : knop}
    </button>
  )

  return (
    <div className={className}>
      {kop ? kop(knopElement) : knopElement}
      {open ? (
        <div id={paneelId} className={paneelClassName}>
          {children}
        </div>
      ) : null}
    </div>
  )
}
